import './Style/LandingPage.css'
import Header from '../Components/Header';
import Banner from '../Image/Banner.png';
import RecipesDisplay from '../Components/Recipes/RecipesDisplay'
import Footer from '../Components/Footer'
export default function LandingPage(){
    return(
        <>
            <Header/>
            <div className='bannerBackground'>
                <img src={Banner} alt="banner" id="banner"/>
            </div>
            <div className='bannerContainer'>
                <img src={Banner} alt="banner" id="banner"/>
            </div>
            <RecipesDisplay/>
            <Footer/>
        </>
    )
}